// src/constants/avatars.ts

export const AVATARS = [
  `${process.env.PUBLIC_URL}/img/Moroarte_OOOhh.jpg`,
  `${process.env.PUBLIC_URL}/img/moroarteCRINGE.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroarteDea2.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroarteNoSe.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroarteParodia.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroartePiedad.jpeg`,
  `${process.env.PUBLIC_URL}/img/MoroarteSabiduria.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroarteSpirit.jpg`,
  `${process.env.PUBLIC_URL}/img/MoroColombres.jpg`,
  `${process.env.PUBLIC_URL}/img/MroarteRockero.jpg`,
];
